import { WalletDto } from './WalletDto';
import { KeyPair } from './keyPair';
import { CryptoLib } from './crypto';
import { Utils } from './utils';

export class CilWalletDto extends WalletDto {
  private wallet: KeyPair;
  // @ts-ignore
  fileVersion = 1.2;

  // @ts-ignore
  constructor(privateKey: string = null, keyFile: string | null = null) {
    super(privateKey, keyFile);
    if (privateKey) {
      this.wallet = KeyPair.keyPairFromPrivate(privateKey);
    }
    else if (keyFile) {
      this.wallet = <KeyPair>{};
    }
    else {
      this.wallet = KeyPair.createKeyPair();
    }

    this.address = this.wallet.address;
    this.publicKey = this.wallet.publicKey;
    this.privateKey = this.wallet.privateKey;
  }

  async encrypt(password: string): Promise<void> {
    const objEncryptedPk = await CryptoLib.encrypt(this.privateKey, password);
    let walletDtoPrepare = {
      address: 'Ux' + this.address,
      ...Utils.prepareForStringifyObject(objEncryptedPk),
      version: this.fileVersion
    };
    let keyFile = this.addHash(walletDtoPrepare);
    this.keyFile = JSON.stringify(keyFile);
  }

  async decrypt(password: string): Promise<void> {
    // @ts-ignore
    const privateKey = (await CryptoLib.decrypt(this.keyFile, password)).toString();
    this.wallet = KeyPair.keyPairFromPrivate(privateKey);
    this.address = this.wallet.address;
    this.publicKey = this.wallet.publicKey;
    this.privateKey = this.wallet.privateKey;
  }

  // @ts-ignore
  sign(tran): Promise<string> {
    // @ts-ignore
    return undefined;
  }

  getAddress(): string {
    return 'Ux' + this.wallet.address;
  }

  getKeyFileName(): string {
    return 'UBX-KeyStore-' + new Date().toISOString();
  }

  getAddressFromKeyFile(): string {
    if (typeof this.keyFile === "string") {
      const {address} = JSON.parse(this.keyFile);
      return address;
    }
    return '';
  }
}
